// extracted by mini-css-extract-plugin
export default {"cls1":"pNNc2gTBQmf5czqSmgTB","cls2":"a9Hjtazm_YSd2Gg5nMtw pNNc2gTBQmf5czqSmgTB"};